import olIcon from 'ol/style/Icon.js';

class Icon extends olIcon {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }

    
}

export default Icon;